<template>
    <v-container>
        <v-dialog v-model="editDialog" max-width="860px" persistent>
            <v-card>
                <v-card-title>{{dialogTitle}} Special Level Assets</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="4">
                                <v-select v-model="itemEdit.platform" :items="platformItems" label="Platform" @change="onPlatformChange"></v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="itemEdit.country" label="Country Code" hint="AA means global default" persistent-hint maxlength="2" @input="normalizeCountryInput"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="itemEdit.note" label="Note"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="itemEdit.startDate" label="Start Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="itemEdit.startDate" @input="startMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="itemEdit.endDate" label="End Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="itemEdit.endDate" @input="endMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-file-input label="Unity Assets Bundle" prepend-icon="mdi-package-variant-closed" :loading="uploading" :disabled="uploading" @change="fileuploadChange">
                                    <template v-slot:selection="{ text }">
                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                    </template>
                                </v-file-input>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="itemEdit.assets_url" label="Assets URL" readonly></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="DialogCancel">Cancel</v-btn>
                    <v-btn color="primary" :loading="saving" @click="DialogSave">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card outlined class="assets-panel">
            <v-card-title class="assets-toolbar">
                <div>
                    <div class="text-h6">Tile Travel Special Level Assets</div>
                    <div class="caption grey--text text--darken-1">Current page: active {{activeCnt}}, scheduled {{futureCnt}}, expired {{expiredCnt}}</div>
                </div>
                <v-spacer></v-spacer>
                <v-chip small class="mr-2" color="green lighten-5" text-color="green darken-3">
                    <v-icon left small>mdi-check-circle</v-icon>
                    Active
                </v-chip>
                <v-chip small class="mr-2" color="blue lighten-5" text-color="blue darken-3">
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Scheduled
                </v-chip>
                <v-chip small class="mr-4" color="orange lighten-5" text-color="orange darken-3">
                    <v-icon left small>mdi-calendar-remove</v-icon>
                    Expired
                </v-chip>
                <v-btn color="primary" depressed @click="addDialog">
                    <v-icon left>mdi-plus</v-icon>
                    Add
                </v-btn>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="serverLength"
                :loading="loading"
                :item-class="getRowClass"
                class="assets-table"
            >
                <template v-slot:item.status="{ item }">
                    <v-chip small :color="getStatusColor(item.status)" :text-color="getStatusTextColor(item.status)">
                        <v-icon left small>{{getStatusIcon(item.status)}}</v-icon>
                        {{item.statusText || getStatusText(item.status)}}
                    </v-chip>
                </template>
                <template v-slot:item.platform="{ item }">
                    <v-chip small outlined color="indigo">{{item.platform}}</v-chip>
                </template>
                <template v-slot:item.assets_url="{ item }">
                    <a class="asset-link" :href="item.assets_url" target="_blank">{{item.assets_url}}</a>
                </template>
                <template v-slot:item.country="{ item }">
                    <v-chip small :color="item.country === 'AA' ? 'grey lighten-3' : 'blue-grey lighten-5'" :text-color="item.country === 'AA' ? 'grey darken-2' : 'blue-grey darken-3'">{{item.country || 'AA'}}</v-chip>
                </template>
                <template v-slot:item.startDate="{ item }">
                    <v-chip small label :color="getDateColor(item)" :text-color="getDateTextColor(item)">{{item.startDate}}</v-chip>
                </template>
                <template v-slot:item.endDate="{ item }">
                    <v-chip small label :color="getDateColor(item)" :text-color="getDateTextColor(item)">{{item.endDate}}</v-chip>
                </template>
                <template v-slot:item.uploadTime="{ item }">
                    <v-chip small>{{getTimeStrFromTimestamp(item.uploadTime)}}</v-chip>
                </template>
                <template v-slot:item.modifyTime="{ item }">
                    <v-chip small>{{getTimeStrFromTimestamp(item.modifyTime)}}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import {bus} from '@/main'

export default ({
    name: "TileTravelSpecialLevelAssets",
    data: function(){
        return {
            headers: [
                { text: "Status", align: "center", sortable: false, value: "status", width: "9%" },
                { text: "Platform", align: "center", sortable: false, value: "platform", width: "8%" },
                { text: "Country", align: "center", sortable: false, value: "country", width: "8%" },
                { text: "Start Date", align: "center", sortable: false, value: "startDate", width: "10%" },
                { text: "End Date", align: "center", sortable: false, value: "endDate", width: "10%" },
                { text: "Assets URL", align: "center", sortable: false, value: "assets_url", width: "34%" },
                { text: "Note", align: "center", sortable: false, value: "note", width: "10%" },
                { text: "Upload Time", align: "center", sortable: false, value: "uploadTime", width: "10%" },
                { text: "Modify Time", align: "center", sortable: false, value: "modifyTime", width: "10%" },
                { text: "Actions", align: "center", sortable: false, value: "actions", width: "8%" },
            ],
            platformItems: ["android", "ios"],
            loading: false,
            saving: false,
            uploading: false,
            editDialog: false,
            startMenu: false,
            endMenu: false,
            options: {},
            items: [],
            serverLength: 0,
            isModifying: false,
            itemEdit: {
                _id: '',
                platform: 'android',
                country: 'AA',
                startDate: '',
                endDate: '',
                assets_url: '',
                note: '',
            },
        }
    },
    computed: {
        dialogTitle: function(){
            return this.isModifying ? "Modify" : "New";
        },
        activeCnt: function(){
            return this.items.filter(item => item.status === "active").length;
        },
        futureCnt: function(){
            return this.items.filter(item => item.status === "future").length;
        },
        expiredCnt: function(){
            return this.items.filter(item => item.status === "expired").length;
        },
    },
    watch: {
        options:{
            handler(){
                this.reloadData();
            },
            deep: true,
        },
    },
    methods: {
        clearItemEdit: function(){
            this.isModifying = false;
            this.itemEdit = {
                _id: '',
                platform: 'android',
                country: 'AA',
                startDate: '',
                endDate: '',
                assets_url: '',
                note: '',
            };
        },
        normalizeCountryInput: function(){
            this.itemEdit.country = (this.itemEdit.country || '').toUpperCase();
        },
        onPlatformChange: function(){
            this.itemEdit.assets_url = '';
        },
        getTimeStrFromTimestamp(timestamp){
            if(!timestamp){
                return "";
            }
            var s = new Date(timestamp * 1000);
            return s.toLocaleString("zh-CN");
        },
        getStatusText: function(status){
            if(status === "active"){
                return "Active";
            }
            if(status === "future"){
                return "Scheduled";
            }
            if(status === "expired"){
                return "Expired";
            }
            return "Unknown";
        },
        getStatusColor: function(status){
            if(status === "active"){
                return "green lighten-5";
            }
            if(status === "future"){
                return "blue lighten-5";
            }
            if(status === "expired"){
                return "orange lighten-5";
            }
            return "red lighten-5";
        },
        getStatusTextColor: function(status){
            if(status === "active"){
                return "green darken-3";
            }
            if(status === "future"){
                return "blue darken-3";
            }
            if(status === "expired"){
                return "orange darken-3";
            }
            return "red darken-3";
        },
        getStatusIcon: function(status){
            if(status === "active"){
                return "mdi-check-circle";
            }
            if(status === "future"){
                return "mdi-clock-outline";
            }
            if(status === "expired"){
                return "mdi-calendar-remove";
            }
            return "mdi-alert-circle";
        },
        getDateColor: function(item){
            return this.getStatusColor(item.status);
        },
        getDateTextColor: function(item){
            return this.getStatusTextColor(item.status);
        },
        getRowClass: function(item){
            if(item.status === "active"){
                return "tiletravel-row-active";
            }
            if(item.status === "future"){
                return "tiletravel-row-future";
            }
            if(item.status === "expired"){
                return "tiletravel-row-expired";
            }
            if(item.status === "unknown"){
                return "tiletravel-row-unknown";
            }
            return "";
        },
        addDialog: function(){
            this.clearItemEdit();
            this.editDialog = true;
        },
        editItem: function(item){
            this.itemEdit = Object.assign({}, item);
            this.itemEdit.country = this.itemEdit.country || 'AA';
            this.isModifying = true;
            this.editDialog = true;
        },
        fileuploadChange: function(files){
            if(!files){
                return;
            }
            if(this.itemEdit.platform !== "android" && this.itemEdit.platform !== "ios"){
                bus.$emit("showSnackMessage", "Please select platform first", true);
                return;
            }
            this.uploading = true;
            var formData = new FormData();
            formData.append("image", files);
            formData.append("product", "tiletravel");
            formData.append("platform", this.itemEdit.platform);
            var vm = this;
            axios.post("/admin/api/uploadFile", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function(response){
                vm.uploading = false;
                if(response.data.status === 0){
                    vm.itemEdit.assets_url = response.data.data.url;
                }else{
                    bus.$emit("showSnackMessage", "Upload failed " + response.data.msg, true);
                }
            }).catch(function(err){
                vm.uploading = false;
                bus.$emit("showSnackMessage", "Upload failed " + err, true);
            })
        },
        deleteItem: function(item){
            var vm = this;
            this.$confirm("Confirm delete?").then(res => {
                if(res === true){
                    var form = new FormData();
                    form.append("_id", item._id);
                    axios.post("/admin/api/tiletravel/delSpecialLevelAssets", form, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function(response){
                        if(response.data.status === 0){
                            bus.$emit("showSnackMessage", "Delete success");
                            vm.reloadData();
                        }else{
                            bus.$emit("showSnackMessage", "Delete failed: " + response.data.msg, true);
                        }
                    }).catch(function(err){
                        bus.$emit("showSnackMessage", "Delete error: " + err, true);
                    })
                }
            })
        },
        validateItem: function(){
            this.normalizeCountryInput();
            if(this.itemEdit.platform !== "android" && this.itemEdit.platform !== "ios"){
                bus.$emit("showSnackMessage", "Platform is required", true);
                return false;
            }
            if(!this.itemEdit.country){
                this.itemEdit.country = "AA";
            }
            if(this.itemEdit.country.length !== 2){
                bus.$emit("showSnackMessage", "Country code must be 2 letters", true);
                return false;
            }
            if(!this.itemEdit.startDate || !this.itemEdit.endDate){
                bus.$emit("showSnackMessage", "Start date and end date are required", true);
                return false;
            }
            if(this.itemEdit.startDate > this.itemEdit.endDate){
                bus.$emit("showSnackMessage", "Start date cannot be after end date", true);
                return false;
            }
            if(!this.itemEdit.assets_url){
                bus.$emit("showSnackMessage", "Assets URL is required, please upload bundle first", true);
                return false;
            }
            return true;
        },
        DialogSave: function(){
            if(!this.validateItem()){
                return;
            }
            this.saving = true;
            var vm = this;
            var formData = new FormData();
            formData.append("data", JSON.stringify(this.itemEdit));
            axios.post('/admin/api/tiletravel/addSpecialLevelAssets', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response){
                vm.saving = false;
                if(response.data.status === 0){
                    vm.editDialog = false;
                    vm.clearItemEdit();
                    bus.$emit("showSnackMessage", "Save success");
                    vm.reloadData();
                }else{
                    bus.$emit("showSnackMessage", "Save failed " + response.data.status + " " + response.data.msg, true);
                }
            }).catch(function(error){
                vm.saving = false;
                bus.$emit("showSnackMessage", "Save error " + error, true);
            });
        },
        DialogCancel: function(){
            this.editDialog = false;
            this.clearItemEdit();
        },
        reloadData: function(){
            const { page, itemsPerPage } = this.options;
            if(!page || !itemsPerPage){
                return;
            }
            this.loading = true;
            var vm = this;
            axios.get("/admin/api/tiletravel/listSpecialLevelAssets?page="+(page-1)+'&step='+itemsPerPage).then(function(response){
                vm.loading = false;
                if(response.data.status === 0){
                    vm.items = response.data.data.list || [];
                    vm.serverLength = response.data.data.totalCnt;
                }else{
                    bus.$emit("showSnackMessage", "Reload failed " + response.data.msg, true);
                }
            }).catch(function(err){
                vm.loading = false;
                bus.$emit("showSnackMessage", "Reload error " + err, true);
            })
        },
    },
    mounted: function(){
        this.reloadData();
    },
})
</script>

<style>
.assets-panel {
    border-color: #d6dee8 !important;
}

.assets-toolbar {
    border-bottom: 1px solid #edf0f4;
}

.assets-table a,
.asset-link {
    word-break: break-all;
}

.assets-table tbody tr.tiletravel-row-active {
    background-color: #f1fbf4;
}

.assets-table tbody tr.tiletravel-row-active:hover {
    background-color: #e6f7eb !important;
}

.assets-table tbody tr.tiletravel-row-future {
    background-color: #f5f9ff;
}

.assets-table tbody tr.tiletravel-row-expired {
    background-color: #fff8ec;
}

.assets-table tbody tr.tiletravel-row-expired:hover {
    background-color: #fff1d8 !important;
}

.assets-table tbody tr.tiletravel-row-unknown {
    background-color: #fff1f1;
}

.assets-table tbody tr.tiletravel-row-unknown:hover {
    background-color: #ffe3e3 !important;
}
</style>
